import { LMS_WEBAPP_CONFIG_IMPL } from "../../../infecto-lms-webapp-impl/config";
import { safeBase64Encode } from "../../utils/safeUrlBaseGenerator";

export function getUrlToIdentityWithOptionalRedirectBase64(
	action: "login" | "logout",
	hasRedirectBase64: boolean,
	customUrl?: string,
) {
	const currentUrl = customUrl ?? window.location.href;
	const base64Url = safeBase64Encode(currentUrl);
	const base64UrlPath = base64Url.length
		? base64Url
		: process.env.REACT_APP_REDIRECT_BASE_64_APP_BASE;

	return hasRedirectBase64
		? `${process.env.REACT_APP_USER_SYSTEM_BASE}/${action}/${LMS_WEBAPP_CONFIG_IMPL.brandId}/${base64UrlPath}`
		: `${process.env.REACT_APP_USER_SYSTEM_BASE}/${action}/${LMS_WEBAPP_CONFIG_IMPL.brandId}`;
}
